import store from '@/core/store'
import event from '@/util/event'
import commonService from '@/service/commonService.js'

const smeRolesMixin = {
	data() {
		return {
			// Define your mixin-specific data properties here
			permissions: [],
			roles: [],
			availablePermissions: [],
			isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      		enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
		};
	},
	methods: {
		async getAssignedRoles(customerId, corporateId) {
			this.roles = []
			if (!customerId) return

			const response = await commonService.getAssignedUserRoles(customerId, corporateId)
			if (response && !response.causes && response?.dehRoleDetails) {
				this.roles = response.dehRoleDetails?.map((role, index) => ({ ...role, enabled: role.assignedFlag === 'Y', index }))
			}
			await this.fetchPermissions(corporateId)
			return this.availablePermissions
		},
		async fetchPermissions(corporateCode, roleCode) {
			try {
				this.permissions = []
				await Promise.all(this.roles.map(async (eachRole) => {
					if (eachRole?.enabled) {
						let corporateId = (eachRole.defaultRoleFlag === 'Y') ? 'GLOBAL' : corporateCode
						let role = eachRole?.roleCode
						let data = await commonService.getSmeRole(corporateId, role)
						if (data && data?.permDetail) {
							this.permissions.push(...data?.permDetail)
						}
						// await this.groupedPerCategory(this.permissions)
						await this.getPermissionsList(this.permissions)
					}
				})
				)
			} catch (error) {
				console.error('Error fetching SME role permissions', error)
				this.permissions = []
			}
		},
		groupedPerCategory(permissions) {
			if (!permissions.length) return []

			const groups = permissions.reduce((acc, item) => {
				const group = acc.find(g => g.category === item.permCategoryCode)
				const mapItem = {
					permissionName: item.permissionCode,
					enabled: item.assignedFlag === 'Y'
				}
				if (group && group.items) {
					const existingItem = group.items.find(i => i.permissionName === item.permissionCode)
					if (!existingItem) group.items.push(mapItem)
				} else {
					acc.push({ category: item.permCategoryCode, items: [mapItem] })
				}
				return acc
			}, [])
			this.availablePermissions = groups.map(group => {
				const items = group.items.map(item => ({ ...item, enabled: item.enabled === 'Y' }))
				return { ...group, items }
			})

			return groups
		},
		async getPermissionsList(permissions) {
			if (!permissions.length) return []
			else {
				permissions.forEach(permDetail => {
					let existingItem = this.availablePermissions?.length ? this.availablePermissions?.includes(permDetail?.permissionCode) : ''
					if (!existingItem && permDetail?.assignedFlag === 'Y') {
						this.availablePermissions.push(permDetail?.permissionCode)
					}
				});
				return this.availablePermissions
			}
		},
		isSmeRoleBasedAccessEnabled () { return this.isSmeLogin && this.enableRoleBasedAccess },
		getFilteredAccounts(unfilteredAccountsList) {
			if (this.isSmeRoleBasedAccessEnabled()) {
				let enabledAccountType, disallowed
				let mapAcc = {
					saving: 'SVGS',
					current: 'CACC',
					notice: 'NACC'
				}
				enabledAccountType = store.getters['profileStore/profileData']?.enabledAccountType
				// Get disallowed account types
				disallowed = Object.keys(enabledAccountType)
					.filter(type => !enabledAccountType[type])
					.map(acc => mapAcc?.[acc])
					.filter(value => Boolean(value))
				
				return unfilteredAccountsList.filter(account => {
					// Check if account contains any disallowed type
					return !disallowed.some(type => account.accountType === type);
				});
			} else return unfilteredAccountsList
		}
	}
}


export default smeRolesMixin